{
  "attempts": "Attempts",
  "camera_open": "Camera open",
  "clear": "Clear log",
  "empty": "Nothing logged yet. Capture something with the camera, then come back.",
  "exif_gps": "GPS in EXIF",
  "exif_orientation": "EXIF orientation",
  "file_age": "File age",
  "had_link": "Had a link",
  "had_photo": "With photo",
  "had_text": "Words typed",
  "heading": "Capture log",
  "intro": "Every capture and every start of the app on this device, newest first. Lab only — for the capture spike and the app's start.",
  "kind_camera_cancelled": "Camera cancelled",
  "kind_capture": "Captured",
  "kind_capture_failed": "Capture failed",
  "kind_capture_queued": "Saved on the phone, waiting to send",
  "kind_location_late": "Location attached after saving",
  "kind_outbox_dropped": "Refused after waiting",
  "kind_outbox_sent": "Sent from the outbox",
  "kind_paste": "Pasted",
  "kind_reloaded": "App reloaded while the camera was open",
  "kind_start": "App started",
  "kind_unreadable": "Photo could not be read",
  "link": "Capture log (lab)",
  "location": "Location",
  "location_accuracy": "Accuracy",
  "location_after_save": "Arrived after save",
  "location_first_fix": "First fix",
  "location_fixes": "Fixes",
  "location_sent": "Saved with the thing",
  "metres": "{value} m",
  "ms": "{value} ms",
  "no": "no",
  "none": "none",
  "not_here": "The capture log exists only in lab.",
  "open_to_save": "Sheet open → saved",
  "original": "From the camera",
  "page_title": "Capture log — TingThings",
  "paste_attached": "Became the photo",
  "paste_files": "Files",
  "paste_types": "Clipboard types",
  "phone_online": "Phone said online",
  "photo_upload_failed": "Photo upload failed",
  "prepare": "Shrinking took",
  "seconds": "{value} s",
  "start_browser": "Browser",
  "start_first_paint": "First paint",
  "start_home": "Home on screen",
  "start_native": "iOS app",
  "start_photos": "Photos ({count})",
  "start_platform": "Platform known",
  "start_ready": "Cover lifted",
  "start_running": "Web app running",
  "start_session": "Session confirmed",
  "start_where": "Where",
  "upload": "Upload",
  "uploaded_as": "Uploaded as",
  "waited": "Waited",
  "yes": "yes"
}
